import { render, staticRenderFns } from "./AccountHolderInvestment.vue?vue&type=template&id=4262fe8c&scoped=true"
import script from "./AccountHolderInvestment.vue?vue&type=script&lang=ts"
export * from "./AccountHolderInvestment.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderInvestment.vue?vue&type=style&index=0&id=4262fe8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4262fe8c",
  null
  
)

export default component.exports